import {useCallback} from 'react';

import {useCommonDataHook} from 'src/hooks/use-common-data-hook';
import {
    getAdvertisementSettings,
    removeAdvertisementSettings,
    updateAdvertisementSettings,
} from 'src/openapi/admin/apis/ConferenceAdvertisementApi';
import {useAppDispatch} from 'src/store/hooks';

import type {GetAdvertisementImage$Request} from 'src/openapi/admin/apis/ConferenceAdvertisementApi';
import type {AdvertisementsSettings} from 'src/openapi/admin/models/AdvertisementsSettings';

export const useAdvertisementSettings = ({conferenceId, settingsType}: GetAdvertisementImage$Request) => {
    const apiDispatch = useAppDispatch();

    const getDispatchAction = useCallback((signal: AbortSignal) => apiDispatch(
        getAdvertisementSettings({conferenceId, settingsType}, {signal}),
    ), [conferenceId, settingsType, apiDispatch]);

    const saveDispatchAction = useCallback(async (data: AdvertisementsSettings, signal: AbortSignal) => {
        if (data.link) {
            const settingsResponse = await apiDispatch(updateAdvertisementSettings({
                conferenceId,
                settingsType,
                advertisementsSettings: {
                    type: settingsType,
                    link: data.link,
                    showingTime: data.showingTime,
                },
            }, {signal}));

            return Promise.resolve({type: '', payload: settingsResponse.payload});
        } else {
            const settingsResponse = await apiDispatch(removeAdvertisementSettings({
                conferenceId,
                settingsType,
            }, {signal}));

            return Promise.resolve({type: '', payload: settingsResponse.payload});
        }
    }, [conferenceId, settingsType, apiDispatch]);

    return useCommonDataHook({
        initValue: {
            type: settingsType,
        },
        getDispatchAction,
        saveDispatchAction,
    });
};
